// CONF
import { CreateConf } from './conf/Create.conf';
import { UpdateConf } from './conf/Update.conf';
import { ListConf } from './conf/List.conf';
import { SearchConf } from './conf/Search.conf';
import { DetailConf } from './conf/Detail.conf';

// REDUX
import { reducer, actions } from './slice';

// SELECTOR
import {
  tag,
  querySelector,
  listSelector,
  detailSelector,
  editSelector,
} from './slice';

// SAGA
import { saga } from './saga';

// API
import { API } from './api';

export { reducer, saga, tag };

const categories = {
  tag,
  query: {
    all: {
      selector: querySelector,
      action: actions.fetchAllAction,
      settings: API.categories,
      populate: '*',
    },

    detail: {
      action: actions.fetchDetailAction,
      settings: API.category,
      populate: '*',
    },
    create: {
      settings: API.create,
    },
    edit: {
      settings: API.update,
    },
    delete: {
      settings: API.delete,
    },
  },
  search: {
    conf: SearchConf,
    actions: {
      search: actions.searchChange,
    },
  },
  list: {
    conf: ListConf,
    actions: {
      pagination: actions.paginationChange,
      sort: actions.sortChange,
    },
    selector: {
      data: listSelector,
    },
    add: {
      to: 'add',
    },
    noTag: true,
  },
  detail: {
    conf: DetailConf,
    selector: {
      data: detailSelector,
    },
    edit: {
      to: 'edit',
    },
  },
  edit: {
    conf: UpdateConf,
    selector: {
      data: editSelector,
    },
  },
  create: {
    conf: CreateConf,
  },
  remove: {
    selector: {
      data: detailSelector,
    },
    navigate: '/settings/categories',
  },
};

export default categories;
